import { render } from "./PasteTextView.vue?vue&type=template&id=27adad21&scoped=true"
import script from "./PasteTextView.vue?vue&type=script&lang=js"
export * from "./PasteTextView.vue?vue&type=script&lang=js"

import "./PasteTextView.vue?vue&type=style&index=0&id=27adad21&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27adad21"]])

export default __exports__